<script>
  import { mapGetters } from 'vuex'
  import * as Helper from '@/modules/helper/index'
  import queryString from 'query-string'
  export default {
    computed: {
      ...mapGetters([
        'AppConfig',
        'MainMenuLayout',
        'MainMenu',
        'DesignSettings',
        'SidePanelActive',
        'ChannelmsgCount'
      ]),
      contentElements() {
        let contentData = this.MainMenu
        let contentElements
        if (Helper.IsValid(contentData.Content)) {
          contentElements = JSON.parse(contentData.Content)
        }
        return contentElements
      },
      getNavStyle() {
        if (Helper.IsValid(this.MainMenu.TitleBarOpacity)) {
          let hashCode = Helper.HashCodeFromInt(this.DesignSettings.AppThemeColor)
          let colorrgb = Helper.hexToRgb(hashCode)
          let navStyle
          if (this.convertBoolean(this.MainMenu.TitleBarTitleMode)) {
            navStyle = {
              'color': Helper.HashCodeFromInt(this.MainMenu.TitleBarFontColor),
              'background-color': 'rgba(' + colorrgb + ',' + this.MainMenu.TitleBarOpacity + ')',
              'font-family': this.MainMenu.TitleBarFontName
            }
          } else {
            navStyle = {
              'color': Helper.HashCodeFromInt(this.MainMenu.TitleBarFontColor),
              'font-family': this.MainMenu.TitleBarFontName,
              'background-image': 'url(' + this.AppConfig.Urls.ContentAssetsBaseUrl + this.MainMenu.TitleBarLogo + ')'
            }
          }
          return navStyle
        }
      },
      getScrollStyle() {
        if (this.convertBoolean(this.MainMenu.ContentScrollable) || Helper.IsScreenCapture()) {
          return 'overflow: hidden !important;'
        } else {
          return ''
        }
      },
      bellIconShown() {
        let count = 0
        let modulesItems = this.AppConfig.Modules.Items
        let chatModule = modulesItems.length && modulesItems.find(x => x.Module_Id == 39)
        if(!Helper.IsNullOrEmpty(Helper.getChatUserLocalId(this.AppConfig.Subscription_Id)) && this.ChannelmsgCount.length > 0 && !Helper.IsDevSim() && chatModule) {
          count  = this.ChannelmsgCount.reduce((accumulator, currentValue) => currentValue.subscriptionId === this.AppConfig.Subscription_Id ? accumulator + currentValue.count : accumulator, 0)
        }
        return count
      }
    },
    watch: {
      MainMenuLayout: function(value) {
        this.$f7.popup.close()
        this.getScrollheight()
        const params = queryString.parse(location.search)
        if (params.devsim === 'true' && this.MainMenuLayout === 2) {
          this.$f7.panel.close()
          this.$f7.panel.allowOpen = true
          setTimeout(() => {
            this.$f7.panel.open('right')
          }, 0)
        } else {
          if (params.devsim === 'true' && this.MainMenuLayout != 2) {
            this.$f7.panel && this.$f7.panel.close('right')
          }
        }
      },
      MainMenu: function() {
        this.getScrollheight()
      }
    },
    mounted() {
      this.getScrollheight()
      // const params = queryString.parse(location.search)
      // if (params.devsim === 'true' && this.MainMenuLayout === 2) {
      //   // this.$f7.panel.open('right')
      // }
    },
    methods: {
      getStyle: function(value) {
        if (Helper.IsValid(value, true)) {
          return {
            'background': 'url(' + this.AppConfig.Urls.ContentAssetsBaseUrl + value + ')'
          }
        } else {
          return ''
        }
      },
      convertBoolean(value) {
        return Helper.IsValid(value) ? Helper.convertBoolean(value) : false
      },
      getScrollheight() {
        if (this.MainMenuLayout === 3 && !this.convertBoolean(this.MainMenu.ContentScrollable)) {
          setTimeout(() => {
            let gridHeight = document.getElementsByClassName('main-menu-gird')[0].clientHeight
            let homeContent = document.getElementsByClassName('home-content')[0]
            homeContent.setAttribute('style', `padding-bottom: ${gridHeight}px !important`);
          }, 0)
        } else if (this.MainMenuLayout === 1 && !this.convertBoolean(this.MainMenu.ContentScrollable)) {
          let homeContent = document.getElementsByClassName('home-content')[0]
          homeContent.setAttribute('style', 'padding-bottom: 60px !important');
        } else {
          let homeContent = document.getElementsByClassName('home-content')[0]
          homeContent.setAttribute('style', 'padding-bottom: 0px !important');
        }
      },
      openurl() {
        this.$f7.views.main.router.navigate('/news-detail-view/10931/5e06e647-7568-4bd2-8593-defde244ce9f')
      }
      // onF7Init() {
      //   console.log('onF7Init')
      //   this.getScrollheight()
      //   const params = queryString.parse(location.search)
      //   if (params.devsim === 'true' && this.MainMenuLayout === 2) {
      //     this.$f7.panel.open('right')
      //   }
      // }
    }
  }
</script>
<template>
  <f7-page :page-content="false" name="home-view">
    <!-- <app-header :header="MainMenu.TitleBarTitle"></app-header> -->
    <f7-navbar  sliding v-if="convertBoolean(MainMenu.TitleBarVisible)" class="home-navbar navbar-background header-navbar" :style="getNavStyle">
      <f7-nav-left>
        <!-- <f7-link></f7-link> -->
      </f7-nav-left>
      <f7-nav-title>
        <template v-if="convertBoolean(MainMenu.TitleBarTitleMode)">
          <div class="title-wrapper">{{MainMenu.TitleBarTitle}}</div>
        </template>
      </f7-nav-title>
      <f7-nav-right v-if="MainMenuLayout === 2">
        <!-- <span  v-if="bellIconShown > 0" class="icon-only-custome">
          <f7-icon icon="icon-bell"><span class="badge">{{bellIconShown}}</span></f7-icon>
        </span> -->
        <f7-link v-if="!SidePanelActive" panel-open="right">
          <f7-icon icon="icon-bars"></f7-icon>
        </f7-link>
        <f7-link v-else panel-close>
          <f7-icon icon="icon-bars"></f7-icon>
        </f7-link>
      </f7-nav-right>
      <f7-nav-right v-else>
        <!-- <span v-if="bellIconShown > 0" class="icon-only-custome">
          <f7-icon icon="icon-bell"><span class="badge">{{bellIconShown}}</span></f7-icon>
         </span> -->
        <!-- <f7-link></f7-link> -->
      </f7-nav-right>
    </f7-navbar>
    <!-- Menu View Component  -->
    <app-tab-menu v-if="MainMenuLayout === 1"></app-tab-menu>
    <!-- <app-side-menu v-if="MainMenuLayout === 2"></app-side-menu> -->
    <app-grid-menu v-if="MainMenuLayout === 3"></app-grid-menu>
    <app-list-menu v-if="MainMenuLayout === 4" :class="{'main-menu-list-ios': $theme.ios}"></app-list-menu>
    <!--BackgroundMode : 1=Fullscreen image, 2=Stacked elements -->
    <div v-if="MainMenu.BackgroundMode === 1" class="startPageImg" :style="getStyle(MainMenu.BackgroundImage)">
    </div>
    <div class="backgroundimg"></div>

    <f7-page-content :style="getScrollStyle" class="home-content" :class="{'notitlebar' : !convertBoolean(MainMenu.TitleBarVisible)}">
      <div v-if="MainMenu.BackgroundMode === 2 && contentElements" class="content-section">
        <component v-for="(el,index) in contentElements.elements" :is="'app-' + el.elementType" :key="index" v-bind="el.properties">
        </component>
      </div>
      <!-- <a :href="`/chat-view/12`" class="button-fill button-big button-raised button-outline button">Open Chat</a> -->
    </f7-page-content>
  </f7-page>
</template>
<style scoped>
  .icon-only-custome {
    width: 54px;
    margin: 0;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    text-align: center;
  }
  .header-navbar >>> div {
    padding: 0 !important;
  }
  .tabstrippadding{
    padding-bottom: 70px!important;
  }
  .tabstrippaddingMenuLayout6{
    padding-bottom: 200px!important;
  }
   @media  screen
    and (min-device-width: 390px)
    and (min-device-height: 844px)
    and (-webkit-device-pixel-ratio: 3) {
      .header-navbar >>> div  {
      padding-top: 10px !important;

      }
    }
</style>




// WEBPACK FOOTER //
// src/components/home/Home.vue